import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./fonts/sohne/sohne-mono-book.otf%22,%22variable%22:%22--font-sohne-mono%22,%22display%22:%22swap%22,%22preload%22:true,%22fallback%22:[%22ui-monospace%22,%22monospace%22],%22adjustFontFallback%22:%22Arial%22}],%22variableName%22:%22sohneMono%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'sohneMono', 'sohneMono Fallback', ui-monospace, monospace",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
